<script>
import Vue from 'vue'
import appConfig from '@src/app.config.json'
import NavBar from '@components/core/nav-bar.vue'
import Footer from '@components/core/core-footer.vue'
import Skeleton from '@components/_base-skeleton.vue'

export default {
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === 'function' ? title(this.$store) : title
      return title ? `${title} | ${appConfig.title}` : appConfig.title
    },
  },
  components: {
    NavBar,
    Footer,
    Skeleton,
  },
  data() {
    return {
      isLoading: true,
      firstLoad: true,
      pageName:
        window.location.pathname.split('/').filter((val) => val)[0] ===
        undefined
          ? window.location.pathname.split('/').filter((val) => val)[0]
          : 'default',
      // pageName: 'default',
      isMobile: global.app.isMobile ? global.app.isMobile : false,
    }
  },
  watch: {
    $route(to, from) {
      this.pageName = to.name
      this.isLoading = true
    },
  },
  beforeCreate() {
    const uri = window.location.search.substring(1)
    const params = new URLSearchParams(uri)
    if (params.get('lang')) {
      localStorage.setItem('lang', params.get('lang'))
    }
  },
  mounted() {
    document.onreadystatechange = () => {
      if (document.readyState === 'complete') {
        var self = this
        self.isLoading = false
        self.firstLoad = false
        this.checkMobile()
      }
    }
  },
  updated() {
    // this.isLoading = false
    if (this.firstLoad === false) {
      var self = this
      Vue.nextTick().then(function() {
        setTimeout(() => {
          self.isLoading = false
          self.firstLoad = false
        }, 500)
      })
    }
  },
  methods: {
    checkMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        window.app.isMobile = true
        this.isMobile = true
      } else {
        window.app.isMobile = false
        this.isMobile = false
      }
    },
  },
}
</script>

<template>
  <div id="app">
    <!--
    Even when routes use the same component, treat them
    as distinct and create the component again.
    -->
    <NavBar />
    <Skeleton
      v-show="isLoading === true"
      :type="pageName === 'default' ? 'default' : pageName"
    ></Skeleton>
    <RouterView v-if="isLoading === false" :key="$route.fullPath" />
    <Footer />
  </div>
</template>

<!-- This should generally be the only global CSS in the app. -->
<style lang="scss">
// Allow element/type selectors, because this is global CSS.
// stylelint-disable selector-max-type, selector-class-pattern

// Normalize default styles across browsers,
// https://necolas.github.io/normalize.css/
@import '~normalize.css/normalize.css';
// Style loading bar between pages.
// https://github.com/rstacruz/nprogress
@import '~nprogress/nprogress.css';

// Design variables and utilities from src/design.
@import '@design';

*,
*::before,
*::after {
  box-sizing: border-box;
}

body {
  background: $white;
  &.unscrolled {
    overflow-y: hidden;
  }
}
#app {
  @extend %typography-small;
}

// ===
// Base element styles
// ===

a,
a:visited {
  color: $color-link-text;
}

h1 {
  @extend %typography-xxlarge;
}

h2 {
  @extend %typography-xlarge;
}

h3 {
  @extend %typography-large;
}

h4 {
  @extend %typography-medium;
}

h5,
h6 {
  @extend %typography-small;
}

// ===
// Vendor
// ===

#nprogress .bar {
  background: $primary;
}
</style>
